<footer id="colophon" class="site-footer footer-primary">
    <div class="top-footer">
       <div class="container">
          <div class="upper-footer">
             <div class="row">
                <div class="col-lg-3 col-sm-6">
                   <aside class="widget widget_text">
                      <div class="footer-logo">
                         <a href="javascript: void(0)" (click)="goToPage('home')"><img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/71ceeedb-5297-4289-b246-87e594f0ff00/public" alt="Logo"></a>
                      </div>
                      <div class="textwidget widget-text">
                        No te quedés con dudas, reservá ahora tu videollamada para obtener la información que necesitás. Te esperamos!
                      </div>
                   </aside>
                </div>
                <div class="col-lg-3 col-sm-6">
                   <!-- <aside class="widget widget_latest_post widget-post-thumb">
                      <h3 class="widget-title">RECENT POST</h3>
                      <ul>
                         <li>
                            <figure class="post-thumb">
                               <a href="blog-archive.html"><img src="assets/images/img21.jpg" alt=""></a>
                            </figure>
                            <div class="post-content">
                               <h6>
                                  <a href="blog-single.html">BEST JOURNEY TO PEACEFUL PLACES</a>
                               </h6>
                               <div class="entry-meta">
                                  <span class="posted-on">
                                     <a href="blog-archive.html">February 17, 2022</a>
                                  </span>
                               </div>
                            </div>
                         </li>
                         <li>
                            <figure class="post-thumb">
                               <a href="blog-archive.html"><img src="assets/images/img22.jpg" alt=""></a>
                            </figure>
                            <div class="post-content">
                               <h6>
                                  <a href="blog-single.html">TRAVEL WITH FRIENDS IS BEST</a>
                               </h6>
                               <div class="entry-meta">
                                  <span class="posted-on">
                                     <a href="blog-archive.html">February 17, 2022</a>
                                  </span>
                               </div>
                            </div>
                         </li>
                      </ul>
                   </aside> -->
                </div>
                <div class="col-lg-3 col-sm-6">
                   <aside class="widget widget_text">
                      <h3 class="widget-title">CONTACTÁ AHORA</h3>
                      <div class="textwidget widget-text">
                         <p>Podemos comenzar ahora a planear tu aventura sólo tenés que escribir !!</p>
                         <ul>
                            <li>
                               <a href="javascript: void(0)">
                                  <i aria-hidden="true" class="icon icon-envelope1"></i>
                                  voyjaleas.cr@.gmail.com
                               </a>
                            </li>
                            <li>
                              <a href="javascript: void(0)">
                                 <i aria-hidden="true" class="icon icon-envelope1"></i>
                                 info@voyjaleas.com
                              </a>
                           </li>
                            <li>
                               <i aria-hidden="true" class="icon icon-map-marker1"></i>
                               Costa Rica / Madrid / Barcelona
                            </li>
                         </ul>
                      </div>
                   </aside>
                </div>
                <div class="col-lg-3 col-sm-6">
                    <aside class="widget widget_text">
                       <h3 class="widget-title">MAPA DEL SITIO</h3>
                       <div class="textwidget widget-text">
                          <ul>
                             <li>
                                <a href="javascript: void(0)" (click)="goToPage('home')">
                                   <i aria-hidden="true" class="icon icon-home"></i>
                                   Inicio
                                </a>
                             </li>
                             <!-- <li>
                                <a href="javascript: void(0)" (click)="goToPage('home/team')">
                                 <i class="fas fa-users"></i>
                                   Nosotros
                                </a>
                             </li> -->
                             <li>
                                <a href="javascript: void(0)" (click)="goToPage('services')">
                                 <i class="fas fa-concierge-bell"></i>
                                   Servicios
                                </a>
                             </li>
                             <li>
                                <a href="javascript: void(0)"  (click)="goToPage('services/packs')">
                                 <i class="fas fa-box-open"></i>
                                   Paquetes
                                </a>
                             </li>
                             <li>
                              <a (click)="goToPage('privacy-policy')">
                               <i class="fas fa-box-open"></i>
                                 Política de privacidad
                              </a>
                           </li>
                             
                          </ul>
                       </div>
                    </aside>
                 </div>
                <!-- <div class="col-lg-3 col-sm-6">
                   <aside class="widget">
                      <h3 class="widget-title">Gallery</h3>
                      <div class="gallery gallery-colum-3">
                         <figure class="gallery-item">
                            <a href="assets/images/img10.jpg" data-fancybox="gallery-1">
                               <img src="assets/images/img21.jpg" alt="">
                            </a>
                         </figure>
                         <figure class="gallery-item">
                            <a href="assets/images/img28.jpg" data-fancybox="gallery-1">
                               <img src="assets/images/img22.jpg" alt="">
                            </a>
                         </figure>
                         <figure class="gallery-item">
                            <a href="assets/images/img14.jpg" data-fancybox="gallery-1">
                               <img src="assets/images/img23.jpg" alt="">
                            </a>
                         </figure>
                         <figure class="gallery-item">
                            <a href="assets/images/img15.jpg" data-fancybox="gallery-1">
                               <img src="assets/images/img24.jpg" alt="">
                            </a>
                         </figure>
                         <figure class="gallery-item">
                            <a href="assets/images/img12.jpg" data-fancybox="gallery-1">
                               <img src="assets/images/img25.jpg" alt="">
                            </a>
                         </figure>
                         <figure class="gallery-item">
                            <a href="assets/images/img13.jpg" data-fancybox="gallery-1">
                               <img src="assets/images/img26.jpg" alt="">
                            </a>
                         </figure>
                      </div>
                   </aside>
                </div> -->
             </div>
          </div>
          <div class="lower-footer">
             <div class="row align-items-center">
                <div class="col-lg-6">
                   <div class="footer-newsletter">
                      <p>Subscríbete ahora para recibr la última información para tus planes !!</p>
                      <form class="newsletter">
                         <input type="email" name="email" placeholder="Email" [formControl]="email" required>
                         <button type="submit" class="outline-btn outline-btn-white" (click)="subscribe()">Subscribirme</button>
                      </form>
                      <mat-error *ngIf="email.invalid">{{getErrorMessage()}}</mat-error>
                   </div>
                </div>
                <div class="col-lg-6 text-right">
                   <div class="social-icon">
                      <ul>
                         <li>
                            <a href="https://www.facebook.com/voyjaleas" target="_blank">
                               <i class="fab fa-facebook-f" aria-hidden="true"></i>
                            </a>
                         </li>
                         <li>
                            <a href="https://www.youtube.com/voyjaleas" target="_blank">
                               <i class="fab fa-youtube" aria-hidden="true"></i>
                            </a>
                         </li>
                         <li>
                            <a href="https://www.instagram.com/voyjaleas" target="_blank">
                               <i class="fab fa-instagram" aria-hidden="true"></i>
                            </a>
                         </li>
                         <li>
                            <a href="https://www.tiktok.com/@voyjaleas" target="_blank">
                               <i class="fab fa-tiktok" aria-hidden="true"></i>
                            </a>
                         </li>
                      </ul>
                   </div>
                   <div class="footer-menu">
                      <ul>
                         <!-- <li>
                            <a href="javascript: void(0)" (click)="goToPage('privacy')">Política de Privacidad</a>
                         </li>
                         <li>
                            <a href="javascript: void(0)" (click)="goToPage('terms')">Términos & Condiciones</a>
                         </li> -->
                         <!-- <li>
                            <a href="javascript: void(0)" (click)="goToPage('faq')">Preguntas Frecuentes</a>
                         </li> -->
                      </ul>
                   </div>
                </div>
             </div>
          </div>
       </div>
    </div>
    <div class="bottom-footer">
       <div class="container">
          <div class="copy-right text-center">Copyright  ©{{currentYear}} | {{companyName}} | Todos los derechos reservados..</div>
       </div>
    </div>
 </footer>